/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoAssignCountriesToGroup } from '../../models/dto-assign-countries-to-group';

export interface CountryControllerAssignCountriesToGroup$Params {
  id: number;
      body: DtoAssignCountriesToGroup
}

export function countryControllerAssignCountriesToGroup(http: HttpClient, rootUrl: string, params: CountryControllerAssignCountriesToGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, countryControllerAssignCountriesToGroup.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

countryControllerAssignCountriesToGroup.PATH = '/country/group/{id}';
